export const NOTIFY_DURATION = 5000;
